export { normalizeLabel } from "../../../shared/lib/normalizeLabel";

export const extractFileName = (name = "") => {
  const withoutExt = name.replace(/\.[^.]+$/, "");
  const parts = withoutExt.split("_");
  return parts[2] ?? parts[parts.length - 1] ?? name;
};

export const isSinGestion = (value = "") => {
  const mgmt = value.trim().toLowerCase();
  return !mgmt || mgmt === "sin gestión" || mgmt === "sin gestion";
};

export const isSinTipoGestion = (value = "") => {
  const type = value.trim().toLowerCase();
  return !type || type === "sin tipo de gestión" || type === "sin tipo de gestion";
};